/**
 * Get the date sort time stamp from row data
 * @param row the row data
 * @param listViewType of the table
 * @returns the lastDeliveryOrRenewTimeStamp and lastDeliveryTimeStamp of the row data
 */
export default function getDateSortTimeStampFromRowData(row, listViewType) {
    var lastDeliveryOrRenewTimeStamp;
    var lastDeliveryTimeStamp;
    switch (listViewType) {
        case 0 /* Conversation */:
            lastDeliveryOrRenewTimeStamp = row.LastDeliveryOrRenewTime;
            lastDeliveryTimeStamp = row.LastDeliveryTime;
            break;
        case 1 /* Message */:
            lastDeliveryOrRenewTimeStamp = row.ReceivedOrRenewTime;
            lastDeliveryTimeStamp = row.DateTimeReceived;
            break;
    }
    return { lastDeliveryOrRenewTimeStamp: lastDeliveryOrRenewTimeStamp, lastDeliveryTimeStamp: lastDeliveryTimeStamp };
}
//# sourceMappingURL=getDateSortTimeStampFromRowData.js.map